// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
exports.push([module.id, "@import url(https://fonts.googleapis.com/css?family=Poppins:300,400,500,600,700&display=swap);"]);
exports.push([module.id, "@import url(https://fonts.googleapis.com/css?family=Roboto:300,400,500,600,700&display=swap);"]);
exports.push([module.id, "@import url(https://fonts.googleapis.com/css2?family=IBM+Plex+Sans:wght@400;500;600;700&display=swap);"]);
// Module
exports.push([module.id, ".label-block{line-height:normal;color:#3c424e;padding-bottom:4px}.value-block{line-height:normal;color:#0b1322;word-break:break-word}\n", ""]);
// Exports
module.exports = exports;
